import { TranscriptFocus } from '../../../coaching-base/general';
import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

export interface EditNotesFocus {
    focus: TranscriptFocus;
}

export const editNotesFocus = createAction<ActionType, EditNotesFocus>(
    ActionType.COACHING_DETAIL__TD__EDIT_NOTES_FOCUS,
);
